import TextField from "../../../../../../components/fields/textfield/TextField";
import {InputAdornment} from "@mui/material";
import {Warning} from "@mui/icons-material";

export interface ErrorFieldPlaceholderProps {
    error: string;
}

export default function ErrorFieldPlaceholder({error}: Readonly<ErrorFieldPlaceholderProps>) {
    return (
            <TextField
                    label={""}
                    value={error}
                    InputProps={{ startAdornment: (<InputAdornment position={"start"}><Warning/></InputAdornment>)}}
                    error={true}
                    variant={"filled"}
                    disabled={true} />
    );
}